import { useSamplesWaterBaseDataDeleteMutation } from "@/services/backend/samples/api/water-base-data-api";
import {
  WaterBaseData,
  waterBaseDataKey,
} from "@/services/backend/samples/types/sample-base-data";
import { DeleteSampleBaseDataDialog } from "@/services/backend/samples/components/delete-sample-base-data-dialog";

export function DeleteWaterBaseDataDialog({
  baseData,
  onDeleted,
}: {
  baseData: WaterBaseData;
  onDeleted?: () => void;
}) {
  const mutation = useSamplesWaterBaseDataDeleteMutation();
  return (
    <DeleteSampleBaseDataDialog
      baseData={baseData}
      dataKey={waterBaseDataKey}
      mutation={mutation}
      onDeleted={onDeleted}
    />
  );
}
